import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { API_BASE_URL, PUSHER_APP_KEY, PUSHER_APP_CLUSTER } from '@/config/env'

// Pusher-js requiere estar disponible en window para que Echo lo encuentre internamente
;(window as unknown as Record<string, unknown>).Pusher = Pusher

let echoInstance: Echo<'pusher'> | null = null
let echoAuthFingerprint: string | null = null

/**
 * Devuelve la instancia singleton de Echo.
 * Se inicializa con el token de autenticación en el momento de la primera llamada
 * o cuando se llama explícitamente a `resetEcho()`.
 *
 * @param token  Bearer token del usuario autenticado (para autenticar canales privados).
 * @param studioId  ID del studio activo (se envía como header de autenticación).
 */
export function getEcho(token: string, studioId: string): Echo<'pusher'> {
  const fingerprint = `${token}:${studioId}`
  if (echoInstance && echoAuthFingerprint === fingerprint) return echoInstance

  if (echoInstance) {
    echoInstance.disconnect()
    echoInstance = null
    echoAuthFingerprint = null
  }

  echoInstance = new Echo({
    broadcaster: 'pusher',
    key: PUSHER_APP_KEY ?? '',
    cluster: PUSHER_APP_CLUSTER,
    forceTLS: true,
    authEndpoint: `${API_BASE_URL}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        'X-Studio-Id': studioId,
      },
    },
  })
  echoAuthFingerprint = fingerprint

  return echoInstance
}

/**
 * Destruye la instancia de Echo (desconecta todos los canales y el WebSocket).
 * Llamar antes de cambiar de studio o al hacer logout.
 */
export function destroyEcho(): void {
  if (echoInstance) {
    echoInstance.disconnect()
    echoInstance = null
    echoAuthFingerprint = null
  }
}
